/*
 * File: /src/components/UIComponents/IncomingCallPlugin/index.js
 * Created Date: Friday November 5th 2021
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Friday, 5th November 2021 10:36:03 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2021 AdBase, Inc.
 */

// Components
import IncomingCall from './IncomingCall';
import ActiveCallDialog from './ActiveCallDialog';
import ActiveWrapUpsDialog from './ActiveWrapUps';

const CallAgentPlugin = {
  install(app, options) {
    /// Global Components
    //  TODO Add in the drop-down components too
    app.component('active-call', ActiveCallDialog);
    app.component('incoming-call', IncomingCall);
    app.component('active-wrap-ups', ActiveWrapUpsDialog);
  }
};

export default CallAgentPlugin;
